import { Pipe, PipeTransform } from '@angular/core';

// Fallback French labels (same as tab_par_codification DEMANDE_TYPE / DEMANDE_STATUS)
// used when the API row carries the raw code without its *_label.
const LABELS: Record<string, string> = {
  NEW: 'Nouvelle licence',
  RENEW: 'Renouvellement',
  EDIT: 'Modification',
  TRANSFER: 'Transfert',
  PENDING: 'Soumise',
  CLUB_ACCEPTED: 'Acceptée (club)',
  FED_VALIDATED: 'Validée',
  LICENCE_GENERATED: 'Licence générée',
  FED_REJECTED: 'Rejetée',
  REJECTED_CLUB: 'Rejetée (club)',
  CANCELLED: 'Annulée',
};

@Pipe({ name: 'demandeLabel', standalone: false })
export class DemandeLabelPipe implements PipeTransform {
  transform(code: string | null | undefined): string {
    if (!code) return '—';
    return LABELS[code] || code;
  }
}
